// industrial-anti-fatigue products (9 items)
export const productsAntiFatigue = [
  {
    id: 20,
    slug: "bubble-mat",
    name: "Bubble Mat",
    variant: "Anti-Fatigue Matting",
    type: "Anti-Fatigue Mat",
    category: "Industrial & Anti-Fatigue",

    categoryId: "industrial-anti-fatigue",    productSheetPdf: "/Assets/pdf/bubble-mat/PS_ISS_BubbleMat.pdf",
    techSpecsPdf: "/Assets/pdf/bubble-mat/PS_TechSpecs_BubbleMat.pdf",
    zoneIcon: "/Assets/icons/zones/Zones_3_icon.svg",
    colorCount: 1,
    sizeFormat: "Mats",
    zones: [3],
      industries: ["Grocery & Convenience Stores", "Retailers", "Hospitality Sector", "Mass Merchandiser", "Financial Institutions", "Government", "Pharmacy & Drugstore", "Specialty Stores"],
      colorTones: ["black"],
      patterns: ["textured"],
      budgetLevels: ["economy", "mid-range"],
    image: "/Assets/images/products/bubble-mat/BubbleMat_thumbnail.jpg",
    heroImage: "/Assets/images/products/bubble-mat/BubbleMat_hero.jpg",
    attributeIcons: [
      { src: "/Assets/icons/attributes/indoor-yes.svg", alt: "Indoor Use" }
    ],
    comparisonSpecs: {
      material: "Black Molded Rubber",
      construction: "rubber",
      backing: "Air pocked “Bubble” design",
      thickness: "0.50 inch",
      trafficRating: "Medium",
      slipResistance: "Yes",
      installationType: "Loose Lay Mat",
      recommendedZone: "Zone 3",
      bestUseCase: "Inlay matting"
    },
    keyFeatures: [
      "Beveled edges increase safety by reducing potential tripping & slipping",
      "Air pockets provide timeless comfort",
      "Grease/Oil Resistant"
    ],
    gallery: [
      "/Assets/images/products/bubble-mat/BubbleMat_-(1).jpg",
      "/Assets/images/products/bubble-mat/BubbleMat_-(2).jpg",
      "/Assets/images/products/bubble-mat/bubble_self_checkout.jpg",
      "/Assets/images/products/bubble-mat/bubble_hd_counter.jpg",
      "/Assets/images/products/bubble-mat/bubble_corner_isolated.jpg",
      "/Assets/images/products/bubble-mat/bubble_black_corner_detail.jpg"
    ],
    swatches: [
      { name: "Black", image: "/Assets/images/products/bubble-mat/swatches/Bubble_Black.jpg" }
    ],
    isPlaceholder: false,
    description: [
      "If you're responsible for your team's performance and safety, you want to create a workspace that keeps your employees comfortable, protected, and productive. The problem is that prolonged standing on hard surfaces puts constant pressure on joints, leading to fatigue, discomfort, and increased risk of injury.",
      "Bubble Mat is designed to help you protect your most important asset: your people. Its 12.7mm-thick molded bubble rubber construction provides a resilient, supportive surface that reduces standing pressure on joints. Workers can stand comfortably for longer periods of time, helping you improve productivity while reducing safety and injury risks."
    ],
    features: [
      "Beveled edges increase safety by reducing potential tripping & slipping",
      "Air pockets provide timeless comfort",
      "Grease/Oil Resistant"
    ],
    specifications: {
      thickness: "1/2\" Molded Rubber Anti-Fatigue matting",
      material: "100% Black Molded Rubber"
    }
  },
  {
    id: 28,
    slug: "kitchen-mat",
    name: "Kitchen Mat",
    variant: "Anti-Fatigue Matting",
    type: "Anti-Fatigue Mat",
    category: "Industrial & Anti-Fatigue",

    categoryId: "industrial-anti-fatigue",    productSheetPdf: "/Assets/pdf/kitchen-mat/PS_ISS_KitchenMat.pdf",
    techSpecsPdf: "/Assets/pdf/kitchen-mat/PS_TechSpecs_KitchenMat.pdf",
    zoneIcon: "/Assets/icons/zones/Zones_3_icon.svg",
    colorCount: 3,
    sizeFormat: "Mats",
    zones: [3],
      industries: ["Grocery & Convenience Stores", "Retailers", "Hospitality Sector", "Mass Merchandiser", "Financial Institutions", "Government", "Pharmacy & Drugstore", "Specialty Stores"],
      colorTones: ["black", "red"],
      patterns: ["textured"],
      budgetLevels: ["economy", "mid-range"],
    image: "/Assets/images/products/kitchen-mat/KitchenMat_thumbnail.jpg",
    heroImage: "/Assets/images/products/kitchen-mat/KitchenMat_hero.jpg",
    attributeIcons: [
      { src: "/Assets/icons/attributes/indoor-yes.svg", alt: "Indoor Use" }
    ],
    comparisonSpecs: {
      material: "Nitrile Rubber",
      construction: "Rectangular walls with drainage holes",
      backing: "smooth backing",
      thickness: "0.50 inch",
      trafficRating: "Medium",
      slipResistance: "Yes",
      installationType: "Loose Lay Mat",
      recommendedZone: "Zone 3",
      bestUseCase: "Inlay matting"
    },
    keyFeatures: [
      "Rectangular Walls with Drainage Holes",
      "Black (for wet areas) & Red (grease/oil resistant)",
      "Grease/Oil Resistant"
    ],
    gallery: [
      "/Assets/images/products/kitchen-mat/kitchen_mat_home_depot_aisle.jpg",
      "/Assets/images/products/kitchen-mat/kitchen_mat_checkout_drawer.jpg",
      "/Assets/images/products/kitchen-mat/kitchen_mat_garden_center.jpg",
      "/Assets/images/products/kitchen-mat/kitchen_mat_red_commercial.jpg",
      "/Assets/images/products/kitchen-mat/KitchenMat_-(1).jpg",
      "/Assets/images/products/kitchen-mat/kitchen_mat_bar.jpg"
    ],
    swatches: [
      { name: "Black", image: "/Assets/images/products/kitchen-mat/Swatches/black.jpg" },
      { name: "Black with GritTuff", image: "/Assets/images/products/kitchen-mat/Swatches/Black-with-GritTuff.jpg" },
      { name: "Red", image: "/Assets/images/products/kitchen-mat/Swatches/red.jpg" }
    ],
    isPlaceholder: false,
    description: [
      "If you manage a kitchen, bar, or industrial workspace, you need flooring that keeps your team safe, comfortable, and productive even in wet and high-grease environments. The problem is that hard, slippery surfaces lead to fatigue, standing discomfort, and increased risk of slips and injuries.",
      "The Industrial Kitchen Mat is designed to solve that problem. Fully launderable and built for wet or dry applications, its open-hole construction allows spilled liquids to drain through the mat, reducing slip hazards in busy work areas."
    ],
    features: [
      "1/2\" Anti-Fatigue matting with Drainage holes",
      "50% Nitrile Rubber",
      "Optional Gritt Tuff carbide grit surface for extra traction"
    ],
    specifications: {
      thickness: "1/2\" Anti-Fatigue matting with Drainage holes",
      material: "50% Nitrile Rubber"
    }
  },
  {
    id: 29,
    slug: "luxury-step",
    name: "Luxury Step",
    variant: "Anti-Fatigue Matting",
    type: "Anti-Fatigue Mat",
    category: "Industrial & Anti-Fatigue",

    categoryId: "industrial-anti-fatigue",    productSheetPdf: "/Assets/pdf/luxury-step/PS_ISS_LuxuryStep.pdf",
    techSpecsPdf: "/Assets/pdf/luxury-step/PS_TechSpecs_LuxuryStep.pdf",
    zoneIcon: "/Assets/icons/zones/Zones_3_icon.svg",
    colorCount: 2,
    sizeFormat: "Mats",
    zones: [3],
      industries: ["Grocery & Convenience Stores", "Retailers", "Hospitality Sector", "Mass Merchandiser", "Financial Institutions", "Government", "Pharmacy & Drugstore", "Specialty Stores"],
      colorTones: ["black", "grey"],
      patterns: ["solid"],
      budgetLevels: ["economy", "mid-range"],
    image: "/Assets/images/products/luxury-step/luxurystep_thumbanil.jpeg",
    heroImage: "/Assets/images/products/luxury-step/luxurystep_hero.jpg",
    attributeIcons: [
      { src: "/Assets/icons/attributes/indoor-yes.svg", alt: "Indoor Use" }
    ],
    comparisonSpecs: {
      material: "Moisture-Resistant closed-cell vinyl sponge",
      construction: "Solid vinyl wear layer",
      backing: "smooth backing",
      thickness: "0.50 inch",
      trafficRating: "Medium",
      slipResistance: "Yes",
      installationType: "Loose Lay Mat",
      recommendedZone: "Zone 3",
      bestUseCase: "Inlay matting"
    },
    keyFeatures: [
      "Solid vinyl wear layer polymerically bound to soft foam",
      "Smooth, non-embossed matte finish",
      "Custom Sizes available at a Premium"
    ],
    gallery: [
      "/Assets/images/products/luxury-step/luxurystep_retail_checkout.jpg",
      "/Assets/images/products/luxury-step/luxurystep_-(1).jpg",
      "/Assets/images/products/luxury-step/luxurystep_product_top.jpg",
      "/Assets/images/products/luxury-step/luxurystep_fashion_fair.jpg",
      "/Assets/images/products/luxury-step/luxurystep_-(3).jpg",
      "/Assets/images/products/luxury-step/LuxurySteps_layers.jpg"
    ],
    swatches: [
      { name: "Black", image: "/Assets/images/products/luxury-step/Swatches/Black.jpg" },
      { name: "Grey", image: "/Assets/images/products/luxury-step/Swatches/Grey.jpg" }
    ],
    isPlaceholder: false,
    description: [
      "If you're responsible for creating a safe and comfortable work environment, you want flooring that protects your team while standing up to daily wear. The problem is that hard surfaces cause fatigue and joint stress, while poorly designed mats can create trip hazards.",
      "Luxury Step is designed with both practicality and performance in mind. Its smooth matte wear layer is puncture resistant and easy to clean, while the expanded foam sponge construction reduces stress on legs and joints."
    ],
    features: [
      "1/2\" Anti-Fatigue matting",
      "Moisture-resistant closed-cell vinyl sponge",
      "Beveled edges help reduce trips, slip, and fall risks"
    ],
    specifications: {
      thickness: "1/2\" Anti-Fatigue matting",
      construction: "Moisture-resistant closed-cell vinyl sponge"
    }
  },
  {
      id: 44,
      slug: "comfort-step-42-iaf",
      name: "Comfort Step 42",
      variant: "Industrial & Anti-Fatigue Mats",
      type: "Industrial & Anti-Fatigue Mats",
      category: "Industrial & Anti-Fatigue",

    categoryId: "industrial-anti-fatigue",
      productSheetPdf: "/Assets/pdf/comfort-step-42-iaf/PS_ISS_ComfortStep42.pdf",
    techSpecsPdf: "/Assets/pdf/comfort-step-42-iaf/PS_TechSpecs_ComfortStep.pdf",
      saleSheetPdf: "/Assets/pdf/comfort-step-42-iaf/PS_ISS_ComfortStep42.pdf",
      zoneIcon: "/Assets/icons/zones/Zones_3_icon.svg",
      colorCount: 6,
      sizeFormat: "Custom",
      zones: [3],
      industries: ["Grocery & Convenience Stores", "Retailers", "Hospitality Sector", "Mass Merchandiser", "Financial Institutions", "Government", "Pharmacy & Drugstore", "Specialty Stores"],
      colorTones: ["black", "grey", "multi-color"],
      patterns: ["ribbed", "textured"],
      budgetLevels: ["economy", "mid-range"],
      image: "/Assets/images/products/comfort-step-42-iaf/comfort-step-42-iaf_thumbnail.jpg",
      heroImage: "/Assets/images/products/comfort-step-42-iaf/comfort-step-42-iaf_hero.jpg",
      attributeIcons: [
        {src: "/Assets/icons/attributes/indoor-yes.svg", alt: "Indoor Use"}
      ],
    comparisonSpecs: {
      material: "Closed-cell Expanded PVC Sponge",
      construction: "Solid vinyl wear layer",
      backing: "smooth backing",
      thickness: "0.375 inch",
      trafficRating: "Medium",
      slipResistance: "Yes",
      installationType: "Loose Lay Mat",
      recommendedZone: "Zone 3",
      bestUseCase: "Inlay matting"
    },
      keyFeatures: ["Surface Aspect with Standard Ribbed or Pebble Emboss"],
      gallery: ["/Assets/images/products/comfort-step-42-iaf/comfort-step-42-iaf_hero.jpg", "/Assets/images/products/comfort-step-42-iaf/comfortstep_warehouse_yellow_border.jpg", "/Assets/images/products/comfort-step-42-iaf/comfortstep_corner_black_pebble.jpg", "/Assets/images/products/comfort-step-42-iaf/comfortstep_corner_black_ribbed.jpg", "/Assets/images/products/comfort-step-42-iaf/comfortstep_corner_yellow_pebble.jpg", "/Assets/images/products/comfort-step-42-iaf/comfortstep_corner_grey_pebble.jpg", "/Assets/images/products/comfort-step-42-iaf/comfort-step-42-iaf_gallery_2.jpg"],
      swatches: [
        {name: "Grey Ribbed", image: "/Assets/images/products/comfort-step-42-iaf/swatches/ComfortStep_Ribbed_Grey.jpg"},
        {name: "Yellow/Black Ribbed", image: "/Assets/images/products/comfort-step-42-iaf/swatches/ComfortStep_Ribbed_YellowBlack.jpg"},
        {name: "Yellow/Black Pebble", image: "/Assets/images/products/comfort-step-42-iaf/swatches/ComfortStep_Pebble_YellowBlack.jpg"},
        {name: "Grey Pebble", image: "/Assets/images/products/comfort-step-42-iaf/swatches/ComfortStep_Pebble_Grey.jpg"},
        {name: "Black Ribbed", image: "/Assets/images/products/comfort-step-42-iaf/swatches/ComfortStep_Ribbed_Black.jpg"},
        {name: "Black Pebble", image: "/Assets/images/products/comfort-step-42-iaf/swatches/ComfortStep_Pebble_Black.jpg"}
      ],
      isPlaceholder: false,
      description: "When employees spend hours standing at workstations, comfort and safety become critical to productivity. Comfort Step 42 provides a resilient anti-fatigue solution designed to reduce pressure on joints and help workers stay comfortable longer. Its 3/8\" thick vinyl construction delivers a supportive standing surface while standing up to demanding environments. Fire- and chemical-resistant, Comfort Step 42 helps facilities create safer, more comfortable work areas in industrial and production settings.",
      features: ["Surface Aspect with Standard Ribbed or Pebble Emboss"],
      specifications: {}
    },
  {
      id: 45,
      slug: "comfort-step-diamond-iaf",
      name: "Comfort Step Diamond",
      variant: "Industrial & Anti-Fatigue Mats",
      type: "Industrial & Anti-Fatigue Mats",
      category: "Industrial & Anti-Fatigue",

    categoryId: "industrial-anti-fatigue",
      productSheetPdf: "/Assets/pdf/comfort-step-diamond-iaf/PS_ISS_ComfortStepDiamond.pdf",
    techSpecsPdf: "/Assets/pdf/comfort-step-diamond-iaf/PS_TSS_ComfortStepDiamond.pdf",
      saleSheetPdf: "/Assets/pdf/comfort-step-diamond-iaf/PS_ISS_ComfortStepDiamond.pdf",
      zoneIcon: "/Assets/icons/zones/Zones_3_icon.svg",
      colorCount: 1,
      sizeFormat: "Custom",
      zones: [3],
      industries: ["Grocery & Convenience Stores", "Retailers", "Hospitality Sector", "Mass Merchandiser", "Financial Institutions", "Government", "Pharmacy & Drugstore", "Specialty Stores"],
      colorTones: ["black"],
      patterns: ["textured"],
      budgetLevels: ["economy", "mid-range"],
      image: "/Assets/images/products/comfort-step-diamond-iaf/comfort-step-diamond-iaf_thumbnail.jpg",
      heroImage: "/Assets/images/products/comfort-step-diamond-iaf/comfort-step-diamond-iaf_hero.jpg",
      attributeIcons: [
        {src: "/Assets/icons/attributes/indoor-yes.svg", alt: "Indoor Use"}
      ],
    comparisonSpecs: {
      material: "closed-cell vinyl sponge",
      construction: "Solid vinyl wear layer",
      backing: "smooth backing",
      thickness: "0.50 inch",
      trafficRating: "Medium",
      slipResistance: "Yes",
      installationType: "Loose Lay Mat",
      recommendedZone: "Zone 3",
      bestUseCase: "Inlay matting"
    },
      keyFeatures: ["High density vinyl foam polymerically bound to a moisture resistant a closed-cell vinyl"],
      gallery: ["/Assets/images/products/comfort-step-diamond-iaf/comfort-step-diamond-iaf_hero.jpg", "/Assets/images/products/comfort-step-diamond-iaf/comfort-step-diamond-iaf_gallery_1.jpg", "/Assets/images/products/comfort-step-diamond-iaf/comfort-step-diamond-iaf_gallery_2.jpg", "/Assets/images/products/comfort-step-diamond-iaf/comfort-step-diamond-iaf_gallery_3.jpg", "/Assets/images/products/comfort-step-diamond-iaf/comfort-step-diamond-iaf_gallery_4.jpg"],
      swatches: [],
      isPlaceholder: false,
      description: "In demanding work environments, employees need flooring that supports comfort without sacrificing durability. Diamond Plate Safety Step is engineered to deliver that balance with a resilient foam cushion that helps reduce fatigue on legs and joints during long hours of standing. Its vinyl-nitrile wear layer is polymetrically bonded, without adhesives, for long-term performance, while the smooth, durable surface allows for easy cleaning. Designed to combine strength, comfort, and reliability, Diamond Plate Safety Step helps create safer and more productive workspaces.",
      features: ["High density vinyl foam polymerically bound to a moisture resistant a closed-cell vinyl"],
      specifications: {}
    },
  {
      id: 46,
      slug: "comfort-step-esd-iaf",
      name: "Comfort Step ESD",
      variant: "Industrial & Anti-Fatigue Mats",
      type: "Industrial & Anti-Fatigue Mats",
      category: "Industrial & Anti-Fatigue",

    categoryId: "industrial-anti-fatigue",
      productSheetPdf: "/Assets/pdf/comfort-step-esd-iaf/PS_ISS_ComfortStepESD.pdf",
    techSpecsPdf: "/Assets/pdf/comfort-step-esd-iaf/PS_TechSpecs_ComfortStepESD.pdf",
      saleSheetPdf: "/Assets/pdf/comfort-step-esd-iaf/PS_ISS_ComfortStepESD.pdf",
      zoneIcon: "/Assets/icons/zones/Zones_3_icon.svg",
      colorCount: 1,
      sizeFormat: "Custom",
      zones: [3],
      industries: ["Grocery & Convenience Stores", "Retailers", "Hospitality Sector", "Mass Merchandiser", "Financial Institutions", "Government", "Pharmacy & Drugstore", "Specialty Stores"],
      colorTones: ["black"],
      patterns: ["textured"],
      budgetLevels: ["economy", "mid-range"],
      image: "/Assets/images/products/comfort-step-esd-iaf/comfort-step-esd-iaf_thumbnail.jpg",
      heroImage: "/Assets/images/products/comfort-step-esd-iaf/comfort-step-esd-iaf_hero.jpg",
      attributeIcons: [
        {src: "/Assets/icons/attributes/indoor-yes.svg", alt: "Indoor Use"}
      ],
    comparisonSpecs: {
      material: "Closed-cell expanded PVC Sponge",
      construction: "Solid vinyl wear layer",
      backing: "smooth backing",
      thickness: "0.375 inch",
      trafficRating: "Medium",
      slipResistance: "Yes",
      installationType: "Loose Lay Mat",
      recommendedZone: "Zone 3",
      bestUseCase: "Inlay matting"
    },
      keyFeatures: ["Fire and chemical resistant with excellent static dissipative properties", "high-performance anti-fatigue mating solution"],
      gallery: ["/Assets/images/products/comfort-step-esd-iaf/comfort-step-esd-iaf_hero.jpg", "/Assets/images/products/comfort-step-esd-iaf/comfort-step-esd-iaf_gallery_1.jpg", "/Assets/images/products/comfort-step-esd-iaf/comfort-step-esd-iaf_gallery_3.jpg", "/Assets/images/products/comfort-step-esd-iaf/comfort-step-esd-iaf_gallery_4.jpg", "/Assets/images/products/comfort-step-esd-iaf/comfort-step-esd-iaf_gallery_5.jpg", "/Assets/images/products/comfort-step-esd-iaf/csesd_grounding_plug_detail.jpg", "/Assets/images/products/comfort-step-esd-iaf/csesd_black_in_use.jpg"],
      swatches: [],
      isPlaceholder: false,
      description: "In environments where static control and employee comfort are essential, flooring must support both safety and productivity. Comfort Step ESD is designed to provide a resilient anti-fatigue surface that helps reduce strain on legs and joints during long hours of standing. Its static dissipative properties help protect sensitive equipment, while fire and chemical resistance support demanding industrial conditions. The result is a reliable matting solution that helps maintain safer, more efficient workspaces.",
      features: ["Fire and chemical resistant with excellent static dissipative properties", "high-performance anti-fatigue mating solution"],
      specifications: {}
    },
  {
      id: 48,
      slug: "diamond-plate-safety-step-iaf",
      name: "Diamond Plate Safety Step",
      variant: "Industrial & Anti-Fatigue Mats",
      type: "Industrial & Anti-Fatigue Mats",
      category: "Industrial & Anti-Fatigue",

    categoryId: "industrial-anti-fatigue",
      productSheetPdf: "/Assets/pdf/diamond-plate-safety-step-iaf/PS_ISS_DiamondPlateSafety.pdf",
    techSpecsPdf: "/Assets/pdf/diamond-plate-safety-step-iaf/PS_TechSpecs_DiamondPlateSafetyStep.pdf",
      saleSheetPdf: "/Assets/pdf/diamond-plate-safety-step-iaf/PS_ISS_DiamondPlateSafety.pdf",
      zoneIcon: "/Assets/icons/zones/Zones_3_icon.svg",
      colorCount: 2,
      sizeFormat: "Custom",
      zones: [3],
      industries: ["Grocery & Convenience Stores", "Retailers", "Hospitality Sector", "Mass Merchandiser", "Financial Institutions", "Government", "Pharmacy & Drugstore", "Specialty Stores"],
      colorTones: ["black", "multi-color"],
      patterns: ["textured"],
      budgetLevels: ["economy", "mid-range"],
      image: "/Assets/images/products/diamond-plate-safety-step-iaf/diamond-plate-safety-step-iaf_thumbnail.jpg",
      heroImage: "/Assets/images/products/diamond-plate-safety-step-iaf/diamond-plate-safety-step-iaf_hero.jpg",
      attributeIcons: [
        {src: "/Assets/icons/attributes/indoor-yes.svg", alt: "Indoor Use"}
      ],
    comparisonSpecs: {
      material: "Fusion-bonded Composite",
      construction: "Solid vinyl wear layer",
      backing: "smooth backing",
      thickness: "0.5625 inch",
      trafficRating: "Medium",
      slipResistance: "Yes",
      installationType: "Loose Lay Mat",
      recommendedZone: "Zone 3",
      bestUseCase: "Inlay matting"
    },
      keyFeatures: ["Fusion-bonded Composite", "3/16\u201d Solid PVC Diamond-patterned", "9/16\u201d Diamond-embossed anti-fatigue mats"],
      gallery: ["/Assets/images/products/diamond-plate-safety-step-iaf/safestep_workshop_drillpress.jpg", "/Assets/images/products/diamond-plate-safety-step-iaf/diamond-plate-safety-step-iaf_gallery_1.jpg", "/Assets/images/products/diamond-plate-safety-step-iaf/safestep_black_flat_product.jpg", "/Assets/images/products/diamond-plate-safety-step-iaf/safestep_yellow_border_flatlay.jpg", "/Assets/images/products/diamond-plate-safety-step-iaf/safestep_yellow_border_corner.jpg"],
      swatches: [
        {name: "Solid Black", image: "/Assets/images/products/diamond-plate-safety-step-iaf/swatches/DPSS_BLK.jpg"},
        {name: "Black with Yellow Border", image: "/Assets/images/products/diamond-plate-safety-step-iaf/swatches/DPSS_BLK_YB_2.jpg"}
      ],
      isPlaceholder: false,
      description: "When workers spend long hours standing, the right matting helps improve both comfort and performance. Diamond Plate Safety Step is engineered to provide that balance with a vinyl-nitrile wear layer polymetrically bonded, adhesive-free, to a resilient foam cushion. The durable surface is easy to clean, while the supportive foam base helps reduce stress on legs and joints throughout the day. Built for demanding work environments, Diamond Plate Safety Step delivers dependable anti-fatigue comfort with long-lasting performance.",
      features: ["Fusion-bonded Composite", "3/16\u201d Solid PVC Diamond-patterned", "9/16\u201d Diamond-embossed anti-fatigue mats"],
      specifications: {}
    },
  {
      id: 49,
      slug: "elite-step-iaf",
      name: "Elite Step",
      variant: "Industrial & Anti-Fatigue Mats",
      type: "Industrial & Anti-Fatigue Mats",
      category: "Industrial & Anti-Fatigue",

    categoryId: "industrial-anti-fatigue",
      productSheetPdf: "/Assets/pdf/elite-step-iaf/PS_ISS_EliteStep.pdf",
    techSpecsPdf: "/Assets/pdf/elite-step-iaf/PS_TechSpecs_EliteStep.pdf",
      saleSheetPdf: "/Assets/pdf/elite-step-iaf/PS_ISS_EliteStep.pdf",
      zoneIcon: "/Assets/icons/zones/Zones_3_icon.svg",
      colorCount: 2,
      sizeFormat: "Custom",
      zones: [3],
      industries: ["Grocery & Convenience Stores", "Retailers", "Hospitality Sector", "Mass Merchandiser", "Financial Institutions", "Government", "Pharmacy & Drugstore", "Specialty Stores"],
      colorTones: ["black", "tan"],
      patterns: ["textured"],
      budgetLevels: ["economy", "mid-range"],
      image: "/Assets/images/products/elite-step-iaf/elite-step-iaf_thumbnail.jpg",
      heroImage: "/Assets/images/products/elite-step-iaf/elite-step-iaf_hero.jpg",
      attributeIcons: [
        {src: "/Assets/icons/attributes/indoor-yes.svg", alt: "Indoor Use"}
      ],
    comparisonSpecs: {
      material: "Moisture-Resistant closed-cell sponge",
      construction: "Solid vinyl wear layer",
      backing: "smooth backing",
      thickness: "0.50 inch",
      trafficRating: "Medium",
      slipResistance: "Yes",
      installationType: "Loose Lay Mat",
      recommendedZone: "Zone 3",
      bestUseCase: "Inlay matting"
    },
      keyFeatures: ["Solid vinyl wear layer polymerically bound to soft, moisture-resistant closed-cell vinyl", "Matte leather-grain emboss surface aspect", "1/2\u201d (470mil) Overall Gauge"],
      gallery: ["/Assets/images/products/elite-step-iaf/elite-step-iaf_hero.jpg", "/Assets/images/products/elite-step-iaf/elite-step-iaf_gallery_1.jpg", "/Assets/images/products/elite-step-iaf/elite-step-iaf_gallery_2.jpg", "/Assets/images/products/elite-step-iaf/elite-step-iaf_gallery_3.jpg"],
      swatches: [
        {name: "Tan", image: "/Assets/images/products/elite-step-iaf/swatches/elite-brown.jpg"},
        {name: "Black", image: "/Assets/images/products/elite-step-iaf/swatches/elite-Black.jpg"}
      ],
      isPlaceholder: false,
      description: "Work areas that require long periods of standing need flooring that supports both comfort and safety. Elite Step is designed to provide a cushioned anti-fatigue surface that helps reduce stress on legs and joints throughout the day. Its durable vinyl wear layer resists moisture and punctures while remaining easy to clean, and beveled edges help minimize trip hazards. Finished with a refined faux-leather appearance, Elite Step delivers a premium matting solution that combines performance with a polished look.",
      features: ["Solid vinyl wear layer polymerically bound to soft, moisture-resistant closed-cell vinyl", "Matte leather-grain emboss surface aspect", "1/2\u201d (470mil) Overall Gauge"],
      specifications: {}
    },
  {
      id: 53,
      slug: "marble-step-20-iaf",
      name: "Marble Step 2.0",
      variant: "Industrial & Anti-Fatigue Mats",
      type: "Industrial & Anti-Fatigue Mats",
      category: "Industrial & Anti-Fatigue",

    categoryId: "industrial-anti-fatigue",
      productSheetPdf: "/Assets/pdf/marble-step-20-iaf/PS_ISS_MarbleStep.pdf",
    techSpecsPdf: "/Assets/pdf/marble-step-20-iaf/PS_TechSpecs_MarbleStep.pdf",
      saleSheetPdf: "/Assets/pdf/marble-step-20-iaf/PS_ISS_MarbleStep.pdf",
      zoneIcon: "/Assets/icons/zones/Zones_3_icon.svg",
      colorCount: 3,
      sizeFormat: "Custom",
      zones: [3],
      industries: ["Grocery & Convenience Stores", "Retailers", "Hospitality Sector", "Mass Merchandiser", "Financial Institutions", "Government", "Pharmacy & Drugstore", "Specialty Stores"],
      colorTones: ["blue", "black", "grey", "multi-color"],
      patterns: ["solid"],
      budgetLevels: ["economy", "mid-range"],
      image: "/Assets/images/products/marble-step-20-iaf/marble-step-20-iaf_thumbnail.jpg",
      heroImage: "/Assets/images/products/marble-step-20-iaf/marble-step-20-iaf_hero.jpg",
      attributeIcons: [
        {src: "/Assets/icons/attributes/indoor-yes.svg", alt: "Indoor Use"}
      ],
    comparisonSpecs: {
      material: "Fusion-bonded Composite",
      construction: "Solid vinyl wear layer",
      backing: "smooth backing",
      thickness: "0.50 inch",
      trafficRating: "Medium",
      slipResistance: "Yes",
      installationType: "Loose Lay Mat",
      recommendedZone: "Zone 3",
      bestUseCase: "Inlay matting"
    },
      keyFeatures: ["Classic beauty that supports your workers throughout the day.", "Beveled edges reduce trip, slip and fall accidents", "Its moisture-resistant engineering makes it suitable for most any environment."],
      gallery: ["/Assets/images/products/marble-step-20-iaf/marble-step-20-iaf_hero.jpg", "/Assets/images/products/marble-step-20-iaf/marble_step_black_flatlay.jpg", "/Assets/images/products/marble-step-20-iaf/marble_step_kitchen_lifestyle.jpg", "/Assets/images/products/marble-step-20-iaf/marble_step_blue_retail.jpg", "/Assets/images/products/marble-step-20-iaf/marble_step_office_copier.jpg", "/Assets/images/products/marble-step-20-iaf/marble-step-20-iaf_gallery_2.jpg", "/Assets/images/products/marble-step-20-iaf/marble-step-20-iaf_gallery_3.jpg"],
      swatches: [
        {name: "Grey White", image: "/Assets/images/products/marble-step-20-iaf/swatches/Marble_Grey-White.jpg"},
        {name: "Blue White", image: "/Assets/images/products/marble-step-20-iaf/swatches/Marble_Blue-White.jpg"},
        {name: "Black White", image: "/Assets/images/products/marble-step-20-iaf/swatches/Marble_Black-White.jpg"}
      ],
      isPlaceholder: false,
      description: "When employees spend long hours on their feet, the right flooring can make a meaningful difference in comfort and safety. Marble Step anti-fatigue matting is designed to reduce stress on legs and joints with an expanded foam sponge base that supports workers throughout the day. Its smooth, puncture-resistant wear layer is easy to clean, while beveled edges help reduce trip and fall risks. Moisture-resistant and built for dependable performance, Marble Step delivers lasting comfort with a clean, professional appearance.",
      features: ["Classic beauty that supports your workers throughout the day.", "Beveled edges reduce trip, slip and fall accidents", "Its moisture-resistant engineering makes it suitable for most any environment."],
      specifications: {}
    },
];
